import { render, staticRenderFns } from "./selectFilm.vue?vue&type=template&id=56c57688&scoped=true&"
import script from "./selectFilm.vue?vue&type=script&lang=js&"
export * from "./selectFilm.vue?vue&type=script&lang=js&"
import style0 from "./selectFilm.vue?vue&type=style&index=0&id=56c57688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c57688",
  null
  
)

component.options.__file = "selectFilm.vue"
export default component.exports